import { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

/**
 * 연간 결제 확정 문안 박스 (기획 전달본 S2·S3).
 *
 * 약관 조항의 유효 요건이라 문안을 임의로 바꾸면 조항 자체가 효력을 잃을 수 있다.
 * 결제 버튼과 같은 화면에 두고 접기·더보기 안에 숨기지 않는다.
 */
export default function AnnualNotice({ children }: Props) {
  return (
    <p className="mt-[14px] whitespace-pre-wrap break-keep rounded-[5px] border border-[#a9c1b8] bg-[#eef3f1] px-[16px] py-[13px] text-[13px] leading-[1.6] text-[#1f4a3d]">
      {children}
    </p>
  )
}
